import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
export function SearchAutocomplete({ onSearch, onChange, getOptionLabel, getOptionSelected, minChars = 3, debounceMs = 400, label, variant, margin, error, helperText, onBlur, fullWidth, disabled }) {
    const [input, setInput] = useState("");
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (input.length < minChars) {
            setOptions([]);
            return;
        }
        let active = true;
        const timer = setTimeout(async () => {
            if (!active)
                return;
            setLoading(true);
            try {
                const results = await onSearch(input);
                if (active)
                    setOptions(results);
            }
            finally {
                if (active)
                    setLoading(false);
            }
        }, debounceMs);
        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [input, onSearch, minChars, debounceMs]);
    return (_jsx(Autocomplete, { options: options, filterOptions: x => x, inputValue: input, getOptionLabel: getOptionLabel, getOptionSelected: getOptionSelected, loading: loading, disabled: disabled, onChange: (_, item) => {
            onChange?.(item);
            setInput(item ? getOptionLabel(item) : "");
        }, onInputChange: (_, val, reason) => {
            if (reason === "input") {
                setInput(val);
                onChange?.(null);
            }
        }, renderInput: params => (_jsx(TextField, { ...params, label: label, variant: variant, margin: margin, error: error, helperText: helperText, onBlur: onBlur, fullWidth: fullWidth, InputProps: {
                ...params.InputProps,
                endAdornment: (_jsxs(_Fragment, { children: [loading ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] }))
            } })) }));
}
//# sourceMappingURL=SearchAutocomplete.js.map